var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{attrs:{"datetime":"time"}},[_vm._v("\n  "+_vm._s(_vm.humanized)+"\n  "),_c('q-tooltip',[_vm._v("\n    "+_vm._s(_vm.fullTime)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }